import React, { useState } from 'react';
import './Main.css';
import Header from './Header/Header';
import Informational from './Informational/Informational';
import { ChartContainer, chartConfigs } from './charts';

/**
 * Main component that serves as the application's primary layout
 * Uses a modular chart system for easy addition/removal of visualizations
 */
const Main = () => {
  // Track which charts are enabled (could be moved to context or redux in a larger app)
  const [enabledCharts, setEnabledCharts] = useState({
    dataVisualization: true,
    cryptoMarkets: true,
    scatterPlot: true
  });

  // Toggle chart visibility
  const toggleChart = (chartId) => {
    setEnabledCharts(prev => ({
      ...prev,
      [chartId]: !prev[chartId]
    }));
  };

  return (
    <div className="main">
      <Header />
      <Informational />
      
      {/* Chart controls */}
      <div className="chart-controls">
        <h3>Visualizações Disponíveis</h3>
        <div className="chart-toggle-buttons">
          <button 
            className={`chart-toggle-btn ${enabledCharts.dataVisualization ? 'active' : ''}`}
            onClick={() => toggleChart('dataVisualization')}
          >
            {enabledCharts.dataVisualization ? '✓ ' : ''}
            Visualização de Dados
          </button>
          
          <button 
            className={`chart-toggle-btn ${enabledCharts.cryptoMarkets ? 'active' : ''}`}
            onClick={() => toggleChart('cryptoMarkets')}
          >
            {enabledCharts.cryptoMarkets ? '✓ ' : ''}
            Mercados Cripto
          </button>
          
          <button 
            className={`chart-toggle-btn ${enabledCharts.scatterPlot ? 'active' : ''}`}
            onClick={() => toggleChart('scatterPlot')}
          >
            {enabledCharts.scatterPlot ? '✓ ' : ''}
            Deputados Performance
          </button>
          
          {/* Add more toggle buttons for new charts here */}
        </div>
      </div>
      
      {/* Charts section */}
      <section className="charts-section">
        {/* DataVisualization chart */}
        {enabledCharts.dataVisualization && (
          <ChartContainer 
            type="DataVisualization"
            config={chartConfigs.dataVisualization}
            className="data-viz-container"
          />
        )}
        
      {/* CryptoMarkets chart */}
      {enabledCharts.cryptoMarkets && (
        <ChartContainer 
          type="CryptoMarkets"
          config={chartConfigs.cryptoMarkets}
          className="crypto-chart-container"
        />
      )}
        
      {/* ScatterPlot chart */}
      {enabledCharts.scatterPlot && (
        <ChartContainer 
          type="ScatterPlot"
          config={chartConfigs.scatterPlot}
          className="scatter-plot-container"
        />
      )}
        
        {/* 
          To add a new chart:
          1. Add configuration to chartConfigs.js
          2. Add the chart component to ChartContainer.jsx
          3. Add it here with the appropriate type and config
          4. Add a toggle button in the chart-controls section
        */}
      </section>
    </div>
  );
};

export default Main;
